import React from 'react';
import { List, Title } from './styles';
import Highlight from './highlight';

const Highlights = ({ color, icon, iconColor, iconSize, items, justify, textSize, title }) => {
  return (
    <>
      {title && (
        <Title bold size="xxs" transform="uppercase">
          {title}
        </Title>
      )}
      <List>
        {items?.map(({ text, ...rest }) => (
          <Highlight key={text} {...{ color, icon, iconColor, iconSize, justify, text, textSize }} {...rest} />
        ))}
      </List>
    </>
  );
};

export default Highlights;
